<template>
  <InfuseSlideInLayout
    :title="title"
    :parent-to="parentTo"
  >
    <InfuseRouterTabLayout :request="accessRequest" :is-loading="isLoading" @refetch="refetch" />

    <template v-slot:header>
      <div class="mb-1">
        <h1 class="text-lg font-semibold text-neutral-700">
          <span v-if="isLoading" class="skeleton inline-block w-64">&emsp;</span>
          <span v-else-if="accessRequest">
            {{ accessRequest.requesterName || accessRequest.requesterEmail }}
          </span>
        </h1>
        <div class="mt-2">
          <span v-if="isLoading" class="skeleton inline-block w-96">&emsp;</span>
          <span v-else-if="accessRequest" class="break-all text-sm text-neutral-500">
            {{ accessRequest.requesterEmail }}
          </span>
        </div>
      </div>
    </template>
  </InfuseSlideInLayout>
</template>

<script setup lang="ts">
import { useAccessRequest } from '@infuse/iam/access-request/queries';
import { InfuseRouterTabLayout, InfuseSlideInLayout } from '@infuse/ui/layouts';
import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const { accessRequest, isLoading, fetchId, refetch } = useAccessRequest();

watch(
  () => route.params.accessRequestId ?? route.params.id,
  (id) => {
    fetchId.value = Array.isArray(id) ? id[0] : id;
  },
  { immediate: true }
);

const title = computed(
  () => accessRequest.value?.requesterName || accessRequest.value?.requesterEmail || ''
);

const parentTo = computed(() => {
  const name = (route.meta?.slideInParent as string | undefined) ?? 'access-requests';
  return { name, params: { ...route.params } };
});
</script>
